import {autosize, getCookie} from '../app.js';
class LearnerComponent extends HTMLElement {
    constructor() {
        // Always call super first in the constructor
        super();
    }

    // Specify observed attributes for watching
    static get observedAttributes() {
        return ['id', 'json'];
    }

    // Lifecycle method called when the custom element is first connected to the document's DOM.
    connectedCallback() {
        var websiteurl = getCookie('WEBSITE_URL');
        const c_websiteurl = websiteurl;
        const c_id = this.id;

        var _chevron = "<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#9ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>";
        var _sectionStyle = 'border:1px solid #e6e7e9;border-radius:6px;margin-bottom:8px;overflow:hidden;';
        var _summaryStyle = 'display:flex;align-items:center;justify-content:space-between;padding:7px 14px;background:#f4f6fa;border-bottom:1px solid #e6e7e9;cursor:pointer;list-style:none;font-size:11px;font-weight:700;letter-spacing:.06em;color:#6b7280;text-transform:uppercase;user-select:none;';
        var _bodyStyle = 'padding:12px 14px;font-size:12px;';
        this.innerHTML = "<h3 id='learner-heading' style='display:none'></h3>" +
            " <form class=\"form-horizontal\" id=\"frm-main\">" +
            "  <input type='hidden' name='id' value='" + this.id + "'>" +
            "  <details open style='" + _sectionStyle + "'>" +
            "    <summary style='" + _summaryStyle + "'>Learner " + _chevron + "</summary>" +
            "    <div style='" + _bodyStyle + "'><div id='learner-container' style='display:none;'></div></div>" +
            "  </details>" +
            "  <details open style='" + _sectionStyle + "'>" +
            "    <summary style='" + _summaryStyle + "'>Mother Info " + _chevron + "</summary>" +
            "    <div style='" + _bodyStyle + "'><div id='mother-container' style='display:none;'></div></div>" +
            "  </details>" +
            "  <details open style='" + _sectionStyle + "'>" +
            "    <summary style='" + _summaryStyle + "'>Father Info " + _chevron + "</summary>" +
            "    <div style='" + _bodyStyle + "'><div id='father-container' style='display:none;'></div></div>" +
            "  </details>" +
            "  <details open class='comments-panel' style='" + _sectionStyle + "'>" +
            "    <summary style='" + _summaryStyle + "'><span style='display:flex;align-items:center;gap:6px;'>Comments <span id='comments-total' style='font-size:10px;background:#e5e7eb;color:#6b7280;border-radius:8px;padding:1px 6px;font-weight:600;'></span></span>" + _chevron + "</summary>" +
            "    <div style='" + _bodyStyle + "'><div id='comments-container' style='display:none;'></div></div>" +
            "  </details>" +
            "  <details open class='communications-panel' style='" + _sectionStyle + "display:none;'>" +
            "    <summary style='" + _summaryStyle + "'><span style='display:flex;align-items:center;gap:6px;'>Communications <span id='communications-total' style='font-size:10px;background:#e5e7eb;color:#6b7280;border-radius:8px;padding:1px 6px;font-weight:600;'></span></span>" + _chevron + "</summary>" +
            "    <div style='" + _bodyStyle + "'><div id='communications-container' style='display:none;'></div></div>" +
            "  </details>" +
            " <br />" +
            "</form>" +
            "";

        this.innerHTML += `
            <div class="modal fade" id="addTodoModal" tabindex="-1" role="dialog" aria-labelledby="addTodoModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="addTodoModalLabel">Add Todo</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <form id="addTodoForm">
                      <div class="mb-3">
                        <label for="todoName" class="form-label">Name</label>
                        <input type="text" class="form-control" id="todoName" name="name" required>
                      </div>
                      <div class="mb-3">
                        <label for="todoDetails" class="form-label">Details</label>
                        <textarea class="form-control" id="todoDetails" name="details"></textarea>
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" id="saveTodoButton">Save Todo</button>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="modal fade" id="editTodoModal" tabindex="-1" role="dialog" aria-labelledby="editTodoModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="editTodoModalLabel">Edit Todo</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <form id="editTodoForm">
                                <div class="mb-3">
                                    <label for="editTodoName" class="form-label">Name</label>
                                    <input type="text" class="form-control" id="editTodoName" required>
                                </div>
                                <div class="mb-3">
                                    <label for="editTodoDetails" class="form-label">Details</label>
                                    <textarea class="form-control" id="editTodoDetails"></textarea>
                                </div>
                                <input type="hidden" id="editTodoId">
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary" id="saveEditTodoButton">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
                `;

        function safeParse(data) {
            if (typeof data === 'string') { try { return JSON.parse(data); } catch(e) { return data; } }
            return data;
        }

        function html_entity_decode(str) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = str;
            return textArea.value;
        }

        // Fetch and render todos
        function renderTodos(learnerId) {

            $('#todos-container').hide();

            $.get(c_websiteurl + 'app.php/todos/json/?learner_id=' + learnerId)
                .done(function (data) {
                    var todos = data;
                    var todosHtml = '';

                    // Render headings if todos present.
                    if (todos.length > 0) {
                        // Get counts.
                        $.get(c_websiteurl + 'app.php/todos/getcountsforlearner/?id=' + learnerId)
                            .done(function (xdata) {
                                var renderCounts = '&nbsp;&nbsp;&nbsp;<span class="badge badge-default" style="background: #64748b"><i class="fa fa-check-circle"></i>&nbsp;&nbsp;' + xdata.countCompleted + ' / ' + xdata.countAll + '&nbsp;&nbsp;&nbsp;(' + xdata.percentage + '%)</span>'
                                todosHtml += '<tr style="background: #e5e7eb">'
                                    + '<th style="min-width: 500px !important;">To Do - Tasks' + renderCounts + '</th>'
                                    + '<th style="width: 120px !important; max-width: 120px !important;">Actions</th>'
                                    + '</tr>';
                                $('#todos-table-head').html(todosHtml);
                                todosHtml = '';

                                todos.forEach(function (todo) {
                                    todosHtml += '<tr>'
                                        + '<td style="min-width: 500px !important;"><strong>' + todo.name + todo.completed_at_formatted + '</strong><br />' + todo.details + '</td>'
                                        + '<td style="width: 120px !important; max-width: 120px !important;">&nbsp;&nbsp;<input type="checkbox" style="position: relative; top: 3px;" class="todo-completed" data-id="' + todo.id + '" ' + (todo.completed ? 'checked' : '') + '>'
                                        + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button style="padding: 1px 3px !important;" class="btn btn-default btn-sm todo-edit" data-id="' + todo.id + '"><i class="fa fa-edit"></i></button>'
                                        + '&nbsp;&nbsp;<button style="padding: 1px 3px !important;" class="btn btn-default btn-sm todo-delete" data-id="' + todo.id + '"><i class="fa fa-trash-o"></i></button>'
                                        + '</td>'
                                        + '</tr>';
                                });
                                $('#todos-table-body').html(todosHtml);

                                // Render table using jquery datatables.
                                // #todos-table.
                                $('#todos-table').DataTable({
                                    "retrieve": true,
                                    "paging": false,
                                    "info": false,
                                    "searching": false,
                                    sort: false,
                                });

                                // Add event listeners for marking todos as done
                                $('.todo-completed').change(function () {
                                    var todoId = $(this).data('id');
                                    var completed = $(this).is(':checked') ? 1 : 0;
                                    $.post(c_websiteurl + 'app.php/todos/checkoruncheck/', {id: todoId, completed: completed})
                                        .done(function () {
                                            renderTodos(learnerId);
                                        });
                                });

                                // Add event listeners for deleting todos
                                $('.todo-delete').click(function () {
                                    var todoId = $(this).data('id');
                                    if (confirm('Are you sure you want to delete this todo?')) {
                                        $.post(c_websiteurl + 'app.php/todos/delete/', {id: todoId})
                                            .done(function () {
                                                renderTodos(learnerId);
                                            });
                                    }
                                });

                                // Add event listeners for editing todos
                                $('.todo-edit').click(function () {
                                    var todoId = $(this).data('id');

                                    // Get todo.
                                    $.get(c_websiteurl + 'app.php/todos/getbyid/?id=' + todoId)
                                        .done(function (data) {
                                                var todoName = data.name;
                                                var todoDetails = data.details;

                                                $('#editTodoId').val(todoId);
                                                $('#editTodoName').val(todoName);
                                                $('#editTodoDetails').val(todoDetails);

                                                fBsModal('editTodoModal', 'show');
                                            }
                                        );
                                });

                                $('#saveEditTodoButton').click(function () {
                                    var todoId = $('#editTodoId').val();
                                    var todoName = $('#editTodoName').val();
                                    var todoDetails = $('#editTodoDetails').val();

                                    if (todoName) {
                                        $.post(c_websiteurl + 'app.php/todos/update/', { id: todoId, name: todoName, details: todoDetails }, function(data) {
                                            // Refresh the todos list
                                            renderTodos(c_id);

                                            fBsModal('editTodoModal', 'hide');
                                        });
                                    }
                                });
                                if (todos.length > 0) {
                                    $('#todos-container').show();
                                }
                            }
                        );
                    }

                });
        }

        function updateDrawerHeader(json) {
            var avatarSrc = c_websiteurl + 'img/' + (json.gender && json.gender.toLowerCase().trim() == 'f' ? 'female-student.png' : 'male-student.png');
            $('#drawer-avatar').html('<img src="' + avatarSrc + '" alt="" />');
            $('#drawer-learner-name').text(json.lastname + ', ' + json.firstname + ' (' + json.id + ')');
            var sub = '';
            if (json.school && json.school.name) {
                sub += '<span><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;vertical-align:middle"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>&nbsp;' + json.school.name + '</span>';
            }
            sub += '<span>Created: ' + json.created_formatted + ' (' + json.created_time_ago + ')</span>';
            sub += '<span>Updated: ' + json.dateStamp_formatted + ' (' + json.dateStamp_time_ago + ')</span>';
            $('#drawer-learner-sub').html(sub);
            var tagsHtml = '';
            var checkSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
            var globeSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>';
            if (json.formID > 0) {
                tagsHtml += '<span class="drawer-tag drawer-tag-website">' + globeSvg + ' Website Form</span>';
            }
            if (json.enabled == 1) {
                tagsHtml += '<span class="drawer-tag drawer-tag-enabled">' + checkSvg + ' Enabled</span>';
            } else {
                tagsHtml += '<span class="drawer-tag drawer-tag-disabled">Disabled</span>';
            }
            if (json.receiveStatements == 1) {
                tagsHtml += '<span class="drawer-tag drawer-tag-statements">' + checkSvg + ' Receive Statements</span>';
            } else {
                tagsHtml += '<span class="drawer-tag drawer-tag-disabled">No Statements</span>';
            }
            if (json.group_name) {
                tagsHtml += '<span class="drawer-tag drawer-tag-group"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg> ' + json.group_name + '</span>';
            }
            tagsHtml += ' <button class="btn btn-sm btn-outline-secondary" id="btn-add-todo" style="font-size:10px;padding:2px 9px;line-height:1.5;border-radius:4px">+ Add To Do</button>';
            $('#drawer-learner-tags').html(tagsHtml);
        }

        function renderAll(id) {
            // Get the learner json.
            $.get(websiteurl + 'app.php/learners/learner/?id=' + id)
                .done(function (data) {
                    var json = safeParse(data);
                    if (!json || json.error || !json.id) {
                        console.error('Failed to load learner:', json);
                        return;
                    }
                    updateDrawerHeader(json);

                    learnerForm(json);
                    motherForm(json);
                    fatherForm(json);
                    commentsBlock(json);
                    communicationsBlock(json);
                    enforceTermLocks({
                        term1Lock: json.term1Lock,
                        term2Lock: json.term2Lock,
                        term3Lock: json.term3Lock,
                        term4Lock: json.term4Lock,
                    });
                    ensureTermLockGuard();

                    // Show notifications (to parents).
                    if (json.notifications != null && json.notifications.length > 1) {
                        $("#notifications-div").toggle();
                    }

                    // When chkConfirm is checked then enable btn-update-learner.
                    document.getElementById('chkConfirm').addEventListener('change', function () {
                        document.getElementById('btn-update-learner').disabled = !this.checked;
                    });

                    $('#btn-update-learner').click(function () {
                        //$("#btn-update-learner").toggle();

                        var hr    = new XMLHttpRequest();
                        var url   = c_websiteurl + "app.php/learners/update/";
                        var vars  = "id=" + c_id + "&data=" + escape( $("#frm-main").serialize() );

                        hr.open("POST", url, true);
                        hr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                        hr.onreadystatechange = function() {
                            if (hr.readyState == 4) {
                                var response = hr.responseText;

                                if (hr.status == 200) {
                                    $('#div-message').html(
                                        '<div class="alert alert-warning" role="alert">' +
                                        '<span style="white-space: pre !important; font-size: 14px;"><i class="fa fa-check-square"></i>&nbsp;&nbsp;&nbsp;' + response + '</span>' +
                                        '</div>'
                                    );
                                } else {
                                    $('#div-message').html(
                                        '<div class="alert alert-danger" role="alert">' +
                                        '<span style="white-space: pre !important; font-size: 14px;"><i class="fa fa-times-circle"></i>&nbsp;&nbsp;&nbsp;Failed.</span>' +
                                        hr.responseText +
                                        '</div>'
                                    );
                                }
                            }
                        }
                        hr.send(vars);
                    });
                });
        }
        function communicationsBlock(json) {
            $.get('/app.php/learners/communications_json/?id=' + json.id)
                .done(function(data) {
                    var json = safeParse(data);

                    if (json != null && json.length > 0) {
                        $("#communications-total").html(json.length);

                        // Build an html table of communications in json:
                        // Columns: lastTry, subject.
                        let table = '<table class="table table-bordered"><thead><tr><th>Date</th><th>Email</th><th>Subject</th></tr></thead><tbody>';

                        //create table rows
                        for(let communication of json){
                            table += `<tr><td>${communication.formattedDate}</td><td>${communication.emailTo}</td><td>${communication.subject}</td></tr>`;
                        }

                        // Close table
                        table += '</tbody></table>';

                        $("#communications-container").html(
                            table
                        );

                        // Sleep 1/2 second and then show.
                        setTimeout(function() {
                            $('.communications-panel').show();
                            $('#communications-container').show();
                        }, 250);
                    }
                });
        }

        function enforceTermLocks(locksOverride) {
            var termLocksRequest = $.get(c_websiteurl + "app.php/learners/termLocks/");
            var currentTermRequest = $.get(c_websiteurl + "app.php/learners/currentTerm/");

            function pickLock(serverVal, overrideVal) {
                var toBool = function (v) {
                    var lv = (v != null && typeof v === 'string') ? v.trim().toLowerCase() : v;
                    var truthy = ['1','true','on','yes','y','locked'];
                    return (lv === 1 || lv === true) || (typeof lv === 'string' && truthy.indexOf(lv) !== -1);
                };
                var s = toBool(serverVal);
                var o = toBool(overrideVal);
                return (s || o) ? 1 : 0;
            }

            $.when(termLocksRequest, currentTermRequest)
                .done(function (locksResponse, currentTermResponse) {
                    var serverLocks = normalizeAjaxPayload(locksResponse);
                    var currentTermData = normalizeAjaxPayload(currentTermResponse);
                    var currentTerm = parseInt(currentTermData.term, 10);

                    var eff = {
                        term1Lock: pickLock(serverLocks.term1Lock, locksOverride && locksOverride.term1Lock),
                        term2Lock: pickLock(serverLocks.term2Lock, locksOverride && locksOverride.term2Lock),
                        term3Lock: pickLock(serverLocks.term3Lock, locksOverride && locksOverride.term3Lock),
                        term4Lock: pickLock(serverLocks.term4Lock, locksOverride && locksOverride.term4Lock)
                    };

                    applyTermLock('#term1', eff.term1Lock, currentTerm === 1);
                    applyTermLock('#term2', eff.term2Lock, currentTerm === 2);
                    applyTermLock('#term3', eff.term3Lock, currentTerm === 3);
                    applyTermLock('#term4', eff.term4Lock, currentTerm === 4);

                    setTimeout(function(){
                        applyTermLock('#term1', eff.term1Lock, currentTerm === 1);
                        applyTermLock('#term2', eff.term2Lock, currentTerm === 2);
                        applyTermLock('#term3', eff.term3Lock, currentTerm === 3);
                        applyTermLock('#term4', eff.term4Lock, currentTerm === 4);
                    }, 250);
                })
                .fail(function () {
                    var fallback = function (data) {
                        var locks = normalizeAjaxPayload([data]);
                        applyTermLock('#term1', locks.term1Lock, false);
                        applyTermLock('#term2', locks.term2Lock, false);
                        applyTermLock('#term3', locks.term3Lock, false);
                        applyTermLock('#term4', locks.term4Lock, false);
                    };
                    $.get(c_websiteurl + "app.php/learners/termLocks/").done(fallback);
                });
        }

        function normalizeAjaxPayload(responseTuple) {
            if (!responseTuple || typeof responseTuple === 'undefined') {
                return {};
            }

            var payload = Array.isArray(responseTuple) ? responseTuple[0] : responseTuple;

            if (typeof payload === 'string') {
                try {
                    payload = JSON.parse(payload);
                } catch (error) {
                    payload = {};
                }
            }

            return payload || {};
        }

        function applyTermLock(selector, lockFlag, isCurrentTerm) {
            var $input = $(selector);

            if ($input.length === 0) {
                return;
            }

            // Fee fields should always be editable regardless of term locks
            var feeFields = ['#term1', '#term2', '#term3', '#term4'];
            if (feeFields.indexOf(selector) !== -1) {
                // Ensure fee fields are always editable
                $input
                    .prop('readonly', false)
                    .removeAttr('readonly')
                    .removeAttr('aria-readonly')
                    .removeAttr('tabindex')
                    .off('.termLock')
                    .removeClass('term-locked');
                return;
            }

            var lockValue = (lockFlag != null && typeof lockFlag === 'string') ? lockFlag.trim().toLowerCase() : lockFlag;
            var truthy = ['1','true','on','yes','y','locked'];
            var isLocked = (lockValue === 1 || lockValue === true) || (typeof lockValue === 'string' && truthy.indexOf(lockValue) !== -1);

            if (isLocked && !isCurrentTerm) {
                if ($input.val().length === 0) {
                    $input.val('0');
                }
                // Enforce read-only at attribute and event level (but NOT disabled, so it submits)
                $input
                    .prop('readonly', true)
                    .attr('readonly', 'readonly')
                    .attr('aria-readonly', 'true')
                    .attr('tabindex', '-1')
                    .on('keydown.termLock input.termLock paste.termLock', function (e) { e.preventDefault(); return false; });
                // Ensure any virtual keyboard or programmatic focus exits
                $input.addClass('term-locked').blur();
            } else {
                // Remove restrictions for current or unlocked term
                $input
                    .prop('readonly', false)
                    .removeAttr('readonly')
                    .removeAttr('aria-readonly')
                    .removeAttr('tabindex')
                    .off('.termLock')
                    .removeClass('term-locked');
            }
        }

        function ensureTermLockGuard() {
            // Fee fields (#term1, #term2, #term3, #term4) are excluded from lock guard
            // as they should always be editable regardless of term locks
            $(document)
                .off('focusin.termLockGuard keydown.termLockGuard input.termLockGuard paste.termLockGuard', '#term1,#term2,#term3,#term4');
        }

        function commentsBlock(json) {
            $("#comments-total").html(json.comments_total);
            $("#comments-container").html('');

            $.get('/app.php/learners/comments/', { id: json.id }, function(data, status) {

                var json = safeParse(data);
                if (!Array.isArray(json)) return;
                json.forEach(function(comment) {
                    var commentHtml = '<div class="well comment" id="comment-' + comment.id + '" style="margin-bottom: 10px;">' +
                        comment.yesnopanel +
                        '<div class="comment-header">' +
                        '<span class="comment-author" style="padding-left: 25px;"><i class="fa fa-user-o"></i> ' + comment.user_fullname + '</span>' +
                        '<span class="comment-date" style="padding-left: 25px;">' + comment.date_formatted + '</span> <span class="text-muted">(' + comment.time_ago + ')</span>' +
                        '<span style="padding-left: 0px;"><button style="padding: 6px; padding-top: 2px; padding-bottom: 2px;" class="btn btn-delete" data-id="' + comment.id + '"><i class="fa fa-trash-o"></i></button></span>' +
                        '</div>' +
                        '<div class="comment-content" style="padding: 15px;"><textarea style="background: #f5f5f5" class="form-control" id="existing-comment-' + comment.id + '">' + comment.value + '</textarea></div>' +
                        "<button style='margin-left: 25px;' disabled type=\"button\" id='btn-update-comment-" + comment.id + "' data-id='" + comment.id + "' class=\"btn btn-sm btn-update\">UPDATE COMMENT</button>" +
                        "<span style='white-space: pre !important;'>&nbsp;&nbsp;&nbsp;<input type=checkbox value='" + comment.id + "' class='checkbox-confirm-update' > Confirm update action. </span>" +
                        '</div>';
                    $("#comments-container").append(commentHtml);
                });

                var commentHtml = '<div class="well comment" style="margin-bottom: 10px;">' +
                    '<div class="comment-header">' +
                    '<span class="" style="padding-left: 25px; font-size: 14px;"><img style="height: 24px; opacity: 0.5; padding-right: 10px;" src="' + c_websiteurl + '/img/new-note.png" /> Add new comment</span>' +
                    '</div>' +
                    '<div class="comment-content" style="padding: 15px;"><textarea style="background: #f5f5f5" class="form-control" name="new-comment" id="new-comment"></textarea></div>' +
                    "<button style='margin-left: 25px;' disabled type=\"button\" id='btn-insert-comment' class=\"btn btn-sm\">INSERT COMMENT</button>" +
                    "<span style='white-space: pre !important;'>&nbsp;&nbsp;&nbsp;<input type=checkbox id=\"chkConfirmComment\"> Confirm insert action. </span>" +
                    '</div>';
                $("#comments-container").append(commentHtml);

                // Sleep 1/2 second and then show.
                setTimeout(function() {
                    $('#comments-container').show();

                    $('textarea').each(function(){
                        autosize(this);
                    }).on('autosize:resized', function(){
                        console.log('textarea height updated');
                    });

                    document.getElementById('chkConfirmComment').addEventListener('change', function () {
                        document.getElementById('btn-insert-comment').disabled = !this.checked;
                    });

                    $('.checkbox-confirm-update').click(function () {
                        // If this checkbox is checked.
                        if (this.checked) {
                            $('#btn-update-comment-' + $(this).val()).prop('disabled', false);
                        } else {
                            $('#btn-update-comment-' + $(this).val()).prop('disabled', true);
                        }
                    });

                    $('.btn-delete').click(function (event) {
                        // Prevent default.
                        event.preventDefault();

                        var id = $(this).data("id");
                        // Confirm delete action.
                        const confirmation = confirm("Are you sure you want to delete?");
                        if (confirmation) {
                            var requestURL = c_websiteurl + 'app.php/learners/deletecomment/';
                            var requestData = {
                                id: id
                            };
                            // Make the POST request
                            $.post(requestURL, requestData, function(response) {
                                //console.log("Server response:", response);
                                renderAll(c_id);
                            }).fail(function() {
                                console.error("The request failed.");
                            });
                        }
                    });

                    $('.btn-update').click(function (event) {
                        event.preventDefault();

                        // Get this element's data-id.
                        var id = $(this).data("id");

                        var requestURL = c_websiteurl + 'app.php/learners/updatecomment/';
                        var requestData = {
                            message: $('#existing-comment-' + id).val(),
                            id: id,
                            parent_id: c_id
                        };
                        // Make the POST request
                        $.post(requestURL, requestData, function(response) {
                            //console.log("Server response:", response);
                            renderAll(c_id);
                        }).fail(function() {
                            console.error("The request failed.");
                        });
                    });

                    $('#btn-insert-comment').click(function (event) {
                        event.preventDefault();

                        var requestURL = c_websiteurl + 'app.php/learners/insertcomment/';
                        var requestData = {
                            message: $('#new-comment').val(),
                            parent_id: c_id
                        };
                        // Make the POST request
                        $.post(requestURL, requestData, function(response) {
                            //console.log("Server response:", response);
                            renderAll(c_id);
                        }).fail(function() {
                            console.error("The request failed.");
                        });
                    });
                }, 250);

            });
        }

        function oldcommentsBlock(json) {
            $("#comments-total").html(json.comments_total);

            $.post('/app.php/learners/getLearnerCommentsPopup/', { learnerID: json.id }, function(data, status) {
                $("#comments-container").html(
                    html_entity_decode(data)
                );
                // Sleep 1/2 second and then show.
                setTimeout(function() {
                    $('#comments-container').show();
                }, 250);

                $(document).on( "click", ".saveLearnerComment", function(e) {
                    setTimeout(function() {
                        renderAll(json.id);
                    }, 250);
                });
            });
        }
        function motherForm(json) {
            $("#mother-container").html(
                "  " +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>First Name</span>" +
                "          <input type=\"text\" class=\"form-control\" id=\"motherFirstname\" name=\"motherFirstname\" value=\"" + html_entity_decode(json.motherFirstname || '') + "\">" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Surname</span>" +
                "          <input type=\"text\" class=\"form-control form-group-sm\" id=\"motherLastname\" name=\"motherLastname\" value=\"" + html_entity_decode(json.motherLastname || '') + "\">" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Cellphone</span>" +
                "          <input type=\"text\" class=\"form-control form-group-sm\" id=\"motherCell\" name=\"motherCell\" value=\"" + html_entity_decode(json.motherCell || '') + "\">" +
                "          <span class=\"input-group-addon\" style='min-width: 50px; background: #f8f9fa;'><img src='/img/tabler/phone.svg' style='height:18px;width:18px;' /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Email</span>" +
                "          <input type=\"email\" class=\"form-control form-group-sm\" id=\"motherEmail\" name=\"motherEmail\" value=\"" + html_entity_decode(json.motherEmail || '') + "\">" +
                "          <span class=\"input-group-addon\" style='min-width: 50px; background: #f8f9fa;'><img src='/img/tabler/mail.svg' style='height:18px;width:18px;' /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>"
            );

            // Sleep 1/2 second and then show.
            setTimeout(function() {
                $('#mother-container').show();
            }, 250);
        }

        function fatherForm(json) {
            $("#father-container").html(
                "  " +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>First Name</span>" +
                "          <input type=\"text\" class=\"form-control\" id=\"fatherFirstname\" name=\"fatherFirstname\" value=\"" + html_entity_decode(json.fatherFirstname || '') + "\">" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Surname</span>" +
                "          <input type=\"text\" class=\"form-control form-group-sm\" id=\"fatherLastname\" name=\"fatherLastname\" value=\"" + html_entity_decode(json.fatherLastname || '') + "\">" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Cellphone</span>" +
                "          <input type=\"text\" class=\"form-control form-group-sm\" id=\"fatherCell\" name=\"fatherCell\" value=\"" + html_entity_decode(json.fatherCell || '') + "\">" +
                "          <span class=\"input-group-addon\" style='min-width: 50px; background: #f8f9fa;'><img src='/img/tabler/phone.svg' style='height:18px;width:18px;' /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Email</span>" +
                "          <input type=\"email\" class=\"form-control form-group-sm\" id=\"fatherEmail\" name=\"fatherEmail\" value=\"" + html_entity_decode(json.fatherEmail || '') + "\">" +
                "          <span class=\"input-group-addon\" style='min-width: 50px; background: #f8f9fa;'><img src='/img/tabler/mail.svg' style='height:18px;width:18px;' /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>"
            );
            $('#father-container').show();
        }

        function learnerForm(json) {

            $.get(c_websiteurl + "app.php/learners/schools_json/")
                .done(function (data) {
                    var schooljson = safeParse(data);
                    var schoolscbo = '<select name="schoolID" id="schoolID" class="form-control">';
                    schoolscbo += '<option value="0">Please select an option...</option>';
                    if (Array.isArray(schooljson)) {
                        schooljson.forEach(school => {
                            schoolscbo += '<option value="' + school.id + '" ' + (json.schoolID == school.id ? 'selected' : '') +   '>' + school.name + '</option>';
                        });
                    }
                    schoolscbo += '</select>';
                    $('#schools-container').html(schoolscbo);

                    // Onchange build school contacts cbo.
                    $('#schoolID').change(function () {
                        var selectedOption = $(this).find('option:selected').text();
                        // Update term payments info.
                        $.get(c_websiteurl + "app.php/learners/school_json/?id=" + $(this).val())
                            .done(function (data) {
                                var schooljson = safeParse(data);
                                $('#term-payments-info').html(
                                    "The base term FEE for <span class='text-danger'>" + schooljson.name + "</span>" +
                                    "             is <span class='text-danger'>R " + schooljson.baseFee + "</span> per term."
                                );
                                // Update term fees.
                                // Disabled 04 Feb 2025. #200: statements to learners on waiting list
                                // $("#term1").val(schooljson.baseFee);
                                // $("#term2").val(schooljson.baseFee);
                                // $("#term3").val(schooljson.baseFee);
                                // $("#term4").val(schooljson.baseFee);
                                if ($("#term1").val().length == 0) {
                                    $("#term1").val('0');
                                }
                                if ($("#term2").val().length == 0) {
                                    $("#term2").val('0');
                                }
                                if ($("#term3").val().length == 0) {
                                    $("#term3").val('0');
                                }
                                if ($("#term4").val().length == 0) {
                                    $("#term4").val('0');
                                }
                                enforceTermLocks();
                            });
                        $.get(c_websiteurl + "app.php/learners/schoolcontacts_json/?id=" + $(this).val())
                            .done(function (data) {
                                var contactjson = safeParse(data);
                                var cbo = '<select name="schoolContactID" class="form-control">';
                                cbo += '<option value="0">Please select an option...</option>';
                                if (Array.isArray(contactjson)) {
                                    contactjson.forEach(contact => {
                                        cbo += '<option value="' + contact.id + '" ' + (json.schoolContactID == contact.id ? 'selected' : '') +  '>' + contact.contactName + ' - ' + contact.contactLocation + '</option>';
                                    });
                                }
                                cbo += '</select>';
                                $('#schoolcontacts-container').html(cbo);
                            });
                    });

                    // Build the standard school contacts.
                    $.get(c_websiteurl + "app.php/learners/schoolcontacts_json/?id=" + json.schoolID)
                        .done(function (data) {
                            var contactjson = safeParse(data);
                            var cbo = '<select name="schoolContactID" class="form-control">';
                            cbo += '<option value="0">Please select an option...</option>';
                            if (Array.isArray(contactjson)) {
                                contactjson.forEach(contact => {
                                    cbo += '<option value="' + contact.id + '" ' + (json.schoolContactID == contact.id ? 'selected' : '') +  '>' + contact.contactName + ' - ' + contact.contactLocation + '</option>';
                                });
                            }
                            cbo += '</select>';
                            $('#schoolcontacts-container').html(cbo);
                        });
                });

            var gradescbo = '<select name="grade" class="form-control">';
            gradescbo += "<option value='0' " + (json.grade == '0' ? 'selected' : '') +  ">Select a school grade</option>";
            gradescbo += "<option value='00' " + (json.grade == '00' ? 'selected' : '') + ">Grade 00</option>";
            gradescbo += "<option value='R' " + (json.grade == 'R' ? 'selected' : '') + ">Grade R</option>";
            gradescbo += "<option value='1' " + (json.grade == '1' ? 'selected' : '') + ">Grade 1</option>";
            gradescbo += "<option value='2' " + (json.grade == '2' ? 'selected' : '') + ">Grade 2</option>";
            gradescbo += "<option value='3' " + (json.grade == '3' ? 'selected' : '') + ">Grade 3</option>";
            gradescbo += "<option value='4' " + (json.grade == '4' ? 'selected' : '') + ">Grade 4</option>";
            gradescbo += "<option value='5' " + (json.grade == '5' ? 'selected' : '') + ">Grade 5</option>";
            gradescbo += "<option value='6' " + (json.grade == '6' ? 'selected' : '') + ">Grade 6</option>";
            gradescbo += "<option value='7' " + (json.grade == '7' ? 'selected' : '') + ">Grade 7</option>";
            gradescbo += '</select>';

            $("#learner-container").html(
                "" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Surname</span>" +
                "          <input type=\"text\" class=\"form-control\" id=\"surname\" name=\"surname\" value=\"" + json.lastname + "\">" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>First Name</span>" +
                "          <input type=\"text\" class=\"form-control form-group-sm\" id=\"name\" name=\"name\" value=\"" + json.firstname + "\">" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <div class=\"col-sm-12\" style='white-space: pre !important;'>" +
                "<span style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-right:12px;'>Gender:</span>" +
                "Boy&nbsp;" +
                "<input type='radio' name='gender' value='m' " + (json.gender == "m" ? "checked" : "") + ">" +
                "  <span>&nbsp;Girl</span>" +
                " <input type='radio' name='gender' value='f' " + (json.gender == "f" ? "checked" : "") + ">" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 120px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Date of Birth</span>" +
                "          <input style='padding-left: 10px;' type='date' id='birthDate' name='birthDate' value='" + json.birthDate + "' >" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\" id='schools-container-wrapper'>" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>School</span>" +
                "          <div id='schools-container' style='flex: 1'></div>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Grade</span>" +
                "          <div style='flex: 1'>" + gradescbo + "</div>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\" id='schoolcontacts-container-wrapper'>" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Teacher</span>" +
                "          <div id='schoolcontacts-container' style='flex: 1'></div>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <div class=\"col-sm-12\" style='white-space: pre !important;'>" +
                "<span style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-right:12px;'>Aftercare:</span>" +
                " Yes&nbsp;" +
                "<input  type='radio' name='aftercare' value='yes' " + (json.aftercare == "yes" ? "checked" : "") + ">" +
                "  <span>&nbsp;&nbsp;No&nbsp;</span>" +
                "<input  type='radio' name='aftercare' value='no' " + (json.aftercare == "no" ? "checked" : "") + ">" +
                "</div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <div class=\"col-sm-12\" style='white-space: pre !important;'>" +
                "<span style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-right:12px;'>Language:</span>" +
                " English" +
                "  <input type='radio' name='language' value='eng' " + (json.language == "eng" ? "checked" : "") + ">" +
                "  <span>&nbsp;&nbsp;Afrikaans&nbsp;</span>" +
                "<input  type='radio' name='language' value='afr' " + (json.language == "afr" ? "checked" : "") + ">" +
                "  </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <div class=\"col-sm-12\" style='white-space: pre !important;'>" +
                "<span style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-right:12px;'>Photographs:</span>" +
                " <input  type='checkbox' name='allowPhotograph' value='1' " + (json.allowPhotograph == "1" ? "checked" : "") + ">&nbsp;&nbsp;ALLOW" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\" style=''>" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 100px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>Allergies</span>" +
                "          <textarea class='form-control' name='allergies'>" + json.allergies + "</textarea>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 120px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>3rd Party Name</span>" +
                "          <input type=\"text\" class=\"form-control form-group-sm\" id=\"thirdPartyName\" name=\"thirdPartyName\" value=\"" + html_entity_decode(json.thirdPartyName || '') + "\">" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\">" +
                "        <div class=\"input-group\">" +
                "          <span class=\"input-group-addon\" style='min-width: 120px; background: #f8f9fa; color: #6b7280; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em;'>3rd Party Email</span>" +
                "          <input type=\"email\" class=\"form-control form-group-sm\" id=\"thirdPartyEmail\" name=\"thirdPartyEmail\" value=\"" + html_entity_decode(json.thirdPartyEmail || '') + "\">" +
                "          <span class=\"input-group-addon\" style='min-width: 50px; background: #f8f9fa;'><img src='/img/tabler/mail.svg' style='height:18px;width:18px;' /></span>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class='card mb-3' style='border:1px solid #e6e7e9;border-radius:6px;overflow:hidden;'>" +
                "      <div class='card-header' style='background:#f4f6fa;padding:10px 16px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #e6e7e9;'>" +
                "        <div style='font-size:12px;font-weight:700;letter-spacing:.05em;color:#6b7280;text-transform:uppercase;'>Term Payments</div>" +
                "        <div style='font-size:11px;color:#6b7280;' id='term-payments-info'>Base fee: <strong class='text-danger'>R " + json.base_term_fee + "</strong> &mdash; <span class='text-muted'>" + json.school_name + "</span></div>" +
                "      </div>" +
                "      <div class='card-body' style='padding:14px 16px;'>" +
                "        <div style='display:flex;gap:12px;flex-wrap:nowrap;'>" +
                "          <div style='flex:1;min-width:0;'>" +
                "            <label style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;display:block;'>Term 1</label>" +
                "            <input type='text' class='form-control form-control-sm' id='term1' name='term1' value='" + json.term1 + "'>" +
                "          </div>" +
                "          <div style='flex:1;min-width:0;'>" +
                "            <label style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;display:block;'>Term 2</label>" +
                "            <input type='text' class='form-control form-control-sm' id='term2' name='term2' value='" + json.term2 + "'>" +
                "          </div>" +
                "          <div style='flex:1;min-width:0;'>" +
                "            <label style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;display:block;'>Term 3</label>" +
                "            <input type='text' class='form-control form-control-sm' id='term3' name='term3' value='" + json.term3 + "'>" +
                "          </div>" +
                "          <div style='flex:1;min-width:0;'>" +
                "            <label style='font-size:11px;font-weight:600;color:#6b7280;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;display:block;'>Term 4</label>" +
                "            <input type='text' class='form-control form-control-sm' id='term4' name='term4' value='" + json.term4 + "'>" +
                "          </div>" +
                "        </div>" +
                "      </div>" +
                "    </div>" +
                "    <div class=\"form-group form-group-compact\">" +
                "      <div class=\"col-sm-12\" style='padding-top: 15px; padding-left: 25px;'>" +
                "        <button disabled type=\"button\" id='btn-update-learner' class=\"btn btn-primary btn-sm\">UPDATE LEARNER</button>" +
                "<span style='white-space: pre !important;'>&nbsp;&nbsp;&nbsp;<input type=checkbox id=\"chkConfirm\"> Confirm update action. </span>" +
                "        <div id='div-message' style='margin: 0px !important; margin-top: 10px !important; '></div>" +
                "      </div>" +
                "    </div>" +
            "    <div class=\"form-group form-group-compact\" id='notifications-div' style='display: none;'>" +
            "      <div class=\"col-sm-12\" style='margin: 25px; width: 93%; padding-top: 15px; padding-left: 25px; background: #f5f5f5; border-radius: 5px;'>" +
            "        <div style='margin: 0px !important; margin-top: 10px !important; '>"
                    + "<h5>Notifications:</h5>"
                    + (json.notifications != null ? json.notifications.replace(/\n/g, "<br />") : '')
                    + "<br />"
                    + "<br />"
                    + "</div>" +
            "      </div>" +
            "    </div>"
            );

            // Sleep 1/2 second and then show.
            setTimeout(function() {
                $('#learner-container').show();
            }, 250);
        }

        if (c_id > 0) {
            // Get the learner json.
            $.get(websiteurl + 'app.php/learners/learner/?id=' + c_id)
                .done(function (data) {
                    var json = safeParse(data);
                    if (!json || json.error || !json.id) {
                        console.error('Failed to load learner:', json);
                        return;
                    }
                    updateDrawerHeader(json);

                    learnerForm(json);
                    motherForm(json);
                    fatherForm(json);
                    commentsBlock(json);
                    communicationsBlock(json);
                    enforceTermLocks({
                        term1Lock: json.term1Lock,
                        term2Lock: json.term2Lock,
                        term3Lock: json.term3Lock,
                        term4Lock: json.term4Lock,
                    });
                    ensureTermLockGuard();

                    // Show notifications (to parents).
                    if (json.notifications != null && json.notifications.length > 1) {
                        $("#notifications-div").toggle();
                    }

                    // When chkConfirm is checked then enable btn-update-learner.
                    document.getElementById('chkConfirm').addEventListener('change', function () {
                        document.getElementById('btn-update-learner').disabled = !this.checked;
                    });

                    // Add todo.
                    $('#btn-add-todo').click(function () {
                        $('#todoDetails').val('');
                        $('#todoName').val('');
                        fBsModal('addTodoModal', 'show');
                    });

                    $('#saveTodoButton').click(function () {
                        var todoName = $('#todoName').val();
                        var todoDetails = $('#todoDetails').val();

                        if (todoName) {
                            fBsModal('addTodoModal', 'hide');
                            $.post(c_websiteurl + 'app.php/todos/store/', { learner_id: c_id, name: todoName, details: todoDetails }, function(data) {
                                // Reload the todos panel component if it's loaded
                                var todosPanel = document.getElementById('drawer-panel-todos');
                                if (todosPanel && todosPanel.innerHTML.trim()) {
                                    todosPanel.innerHTML = '<learner-todos id="' + c_id + '"></learner-todos>';
                                }
                            });
                        }
                    });

                    $('#btn-update-learner').click(function () {
                        //$("#btn-update-learner").toggle();

                        var hr    = new XMLHttpRequest();
                        var url   = c_websiteurl + "app.php/learners/update/";
                        var vars  = "id=" + c_id + "&data=" + escape( $("#frm-main").serialize() );

                        hr.open("POST", url, true);
                        hr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                        hr.onreadystatechange = function() {
                            if (hr.readyState == 4) {
                                var response = hr.responseText;

                                if (hr.status == 200) {
                                    $('#div-message').html(
                                        '<div class="alert alert-warning" role="alert">' +
                                        '<span style="white-space: pre !important; font-size: 14px;"><i class="fa fa-check-square"></i>&nbsp;&nbsp;&nbsp;' + response + '</span>' +
                                        '</div>'
                                    );
                                } else {
                                    $('#div-message').html(
                                        '<div class="alert alert-danger" role="alert">' +
                                        '<span style="white-space: pre !important; font-size: 14px;"><i class="fa fa-times-circle"></i>&nbsp;&nbsp;&nbsp;Failed.</span>' +
                                        hr.responseText +
                                        '</div>'
                                    );
                                }
                            }
                        }
                        hr.send(vars);
                    });
            });
        }
    }
}

window.customElements.define('learner-component', LearnerComponent);
